import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	level: number
}

export const Entry = styled.li<Props>`
	font-family: ${helpers.font.family.header};
	font-size: ${({ theme }) => theme.font.size.base};
	margin: ${({ level }) => (level === 1 ? '8px 0 0' : `0 0 0 ${(level - 1) * 12}px`)};

	> a {
		color: ${({ level, theme }) => (level === 1 ? theme.color.text : theme.color.textMuted)};
	}
`
